import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/tvShows';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-[0_1px_3px_rgba(0,0,0,0.3)]'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6" aria-label="主导航">
        <div className="flex items-center justify-between h-16 max-w-[1440px] mx-auto">
          <Link
            to="/"
            className="flex items-center gap-2 whitespace-nowrap cursor-pointer"
            aria-label="夫妻影院首页"
          >
            <div className="w-9 h-9 flex items-center justify-center">
              <i className="ri-movie-2-line text-accent-500 text-2xl"></i>
            </div>
            <span className="text-lg font-bold text-foreground-100 font-heading tracking-wide">
              夫妻影院
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {categories.slice(0, 6).map((cat) => (
              <Link
                key={cat.slug}
                to={cat.slug === 'all' ? '/' : `/category/${cat.slug}`}
                className={`px-4 py-2 text-sm rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  (cat.slug === 'all' && location.pathname === '/') ||
                  location.pathname === `/category/${cat.slug}`
                    ? 'bg-accent-500/20 text-accent-500 font-medium'
                    : 'text-foreground-300 hover:text-foreground-100 hover:bg-background-200/50'
                }`}
              >
                {cat.name}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-4">
            <div className="relative">
              <div className="w-8 h-8 flex items-center justify-center absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none">
                <i className="ri-search-line text-foreground-500 text-sm"></i>
              </div>
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="搜索电视剧..."
                className="w-52 h-9 pl-10 pr-4 bg-background-200/70 border border-background-300/60 rounded-full text-sm text-foreground-100 placeholder-foreground-600 focus:outline-none focus:border-accent-500/50 transition-colors"
              />
            </div>
            <Link
              to="/about"
              className="text-sm text-foreground-300 hover:text-accent-500 transition-colors whitespace-nowrap cursor-pointer"
            >
              关于我们
            </Link>
          </div>

          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer text-foreground-200"
            aria-label="打开菜单"
          >
            <i className={`ri-${mobileMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>
      </nav>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50/98 backdrop-blur-md border-t border-background-300/30 px-4 py-4">
          <div className="relative mb-4">
            <div className="w-8 h-8 flex items-center justify-center absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none">
              <i className="ri-search-line text-foreground-500 text-sm"></i>
            </div>
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="搜索电视剧..."
              className="w-full h-10 pl-10 pr-4 bg-background-200/70 border border-background-300/60 rounded-full text-sm text-foreground-100 placeholder-foreground-600 focus:outline-none focus:border-accent-500/50 transition-colors"
            />
          </div>
          <div className="flex flex-wrap gap-2">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={cat.slug === 'all' ? '/' : `/category/${cat.slug}`}
                className={`px-4 py-2 text-sm rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  (cat.slug === 'all' && location.pathname === '/') ||
                  location.pathname === `/category/${cat.slug}`
                    ? 'bg-accent-500/20 text-accent-500 font-medium'
                    : 'text-foreground-300 bg-background-200/50'
                }`}
              >
                {cat.name}
              </Link>
            ))}
          </div>
          <Link
            to="/about"
            className="block mt-4 text-sm text-foreground-300 hover:text-accent-500 transition-colors cursor-pointer"
          >
            关于我们
          </Link>
        </div>
      )}
    </header>
  );
}